import { getToken, setToken, removeToken } from '@/utils/auth';
import { resetRouter } from '@/router';
import commonFn from '@/assets/javascripts/common_function.js';
import service from '@/utils/request';
import envConfig from '@/config/env';
import { _ } from 'core-js';

// 作为默认值, 远程加载后覆盖
// 历史cookie数据可能存在,加载顺序 newCurrencyConfig > currency > default
let remoteCurrencyConfig = {};
const oldCurrency = commonFn.getCookie('currency');
const newCurrencyConfig = commonFn.getCookie('newCurrencyConfig');

if (newCurrencyConfig) {
  // 旧的数据可能出错
  try {
    remoteCurrencyConfig = JSON.parse(newCurrencyConfig);
  } catch (e) {
    remoteCurrencyConfig = CONST.CURRENCY_MAP['JPY'];
  }
} else if (oldCurrency) {
  remoteCurrencyConfig = CONST.CURRENCY_MAP[oldCurrency];
} else {
  remoteCurrencyConfig = CONST.CURRENCY_MAP['JPY'];
}

const CHANNEL_MAP = {
  1: '微信',
  2: '支付宝',
  3: 'H5',
};
const packageChannels = codes => {
  const channels = [];
  codes.forEach(item => {
    // 1支付宝
    if (item) {
      channels.push({
        label: Number(item),
        name: CHANNEL_MAP[item],
      });
    }
  });
  return channels;
};
// 新装修迁移cookie校验
const cookieVerify = data => {
  const cookieData = commonFn.getCookie(data);
  if (
    !cookieData ||
    cookieData === 'false' ||
    !['true', 'false'].includes(cookieData)
  ) {
    return false;
  }
  if (cookieData === 'true') {
    return true;
  }
};

const getDefaultState = () => {
  const userChannels = (commonFn.getCookie('userChannels') || '').split(',');
  return {
    token: getToken(),
    name: unescape(commonFn.getCookie('fshopName')),
    accountName: unescape(commonFn.getCookie('accountName')),
    sellerId: commonFn.getCookie('fsellerId'),
    avatar: '',
    accountType: [],
    sellerType: commonFn.getCookie('sellerType'), // 超级管理员
    remoteCurrencyConfig: remoteCurrencyConfig,
    constantInfo: {
      sellerAppletVoList: [],
      sellerType: null,
      countryId: '',
      syncStockFlag: '',
    },
    menuInfo: [],
    // 菜单权限开关
    menuInfoSwitch: [],
    storeMenuInfo: [],
    supplierMenuInfo: [],
    sellerServerStoreStatus: commonFn.getCookie('sellerServerStoreStatus'), // 这个标志是门店自提开启状态 0 未开启 1开启
    yyStoreId: commonFn.getCookie('yyStoreId'), // 门店Id
    channels: packageChannels(userChannels), // 渠道 1:支付宝 2:微信 4:H5 3:支付宝和微信 5:支付宝和H5 6:微信和H5
    // 商户装修灰度是否命中(true 命中  false 未命中)
    sellerDecorateGrayHit: cookieVerify('sellerDecorateGrayHit'),
    // 商户装修灰度是否完整引导初始化（true：完成  false:未完成）
    sellerDecorateForwardInit: cookieVerify('sellerDecorateForwardInit'),
    // 是否有权限看到微信商家券
    wxCouponExhibitFlag: commonFn.getCookie('wxCouponExhibitFlag'),
    isWhiteList: undefined,
  };
};

const state = getDefaultState();

const mutations = {
  SET_WHITE_STATUS: (state, bool) => {
    console.log('SET_WHITE_STATUS', bool);
    state.isWhiteList = bool;
  },
  RESET_STATE: state => {
    Object.assign(state, getDefaultState());
  },
  SET_SELLERID: (state, id) => {
    state.sellerId = id;
    commonFn.setCookie('fsellerId', id, CONST.DEF_COOKIE_TIME);
  },
  SET_SELLERTYPE: (state, id) => {
    state.sellerType = id;
  },
  SET_TOKEN: (state, token) => {
    state.token = token;
  },
  SET_NAME: (state, name) => {
    commonFn.setCookie('fshopName', name, CONST.DEF_COOKIE_TIME);
    state.name = name;
  },
  SET_ACOUNT: (state, accountName) => {
    state.accountName = accountName;
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar;
  },
  SET_CONSTANT_INFO: (state, constantInfo) => {
    state.constantInfo = constantInfo;
    commonFn.setCookie('constantInfo', constantInfo, CONST.DEF_COOKIE_TIME);
  },
  SET_MENU_INFO: (state, menuInfo) => {
    state.menuInfo = menuInfo;
  },
  // 菜单权限开关
  SET_MENU_INFO_SWITCH: (state, menuInfoSwitch) => {
    state.menuInfoSwitch = menuInfoSwitch;
  },
  SET_ACCOUNT_TYPE: (state, accountType) => {
    state.accountType = accountType;
  },
  SET_STORE_MENU_INFO: (state, menuInfo) => {
    state.storeMenuInfo = menuInfo;
  },
  SET_SUPPLIER_MENU: (state, supplierMenuInfo) => {
    state.supplierMenuInfo = supplierMenuInfo;
  },
  SET_CURRENCY: (state, { currency, precision, remoteCurrencyConfig }) => {
    commonFn.setCookie(
      'newCurrencyConfig',
      JSON.stringify(remoteCurrencyConfig),
      CONST.DEF_COOKIE_TIME
    );
    state.remoteCurrencyConfig = remoteCurrencyConfig;
  },
  SET_SELLER_SERVER_STORE_STATUS: (state, status) => {
    commonFn.setCookie(
      'sellerServerStoreStatus',
      status,
      CONST.DEF_COOKIE_TIME
    );
    state.sellerServerStoreStatus = status;
  },
  SET_STORE_ID: (state, id) => {
    commonFn.setCookie('yyStoreId', id, CONST.DEF_COOKIE_TIME);
    state.yyStoreId = id;
  },
  SET_USER_CHANNEL: (state, channelObj) => {
    const channels = [];
    Object.keys(channelObj).forEach(item => {
      if (channelObj[item]) {
        channels.push({
          label: Number(item),
          name: channelObj[item],
        });
      }
    });
    const channelCodes = channels.map(item => item.label).join(',');
    commonFn.setCookie('userChannels', channelCodes, CONST.DEF_COOKIE_TIME);
    state.channels = channels;
  },
  // 装修灰度
  SET_MATERIAL_GRAY: (state, sellerDecorateGrayHit) => {
    commonFn.setCookie(
      'sellerDecorateGrayHit',
      sellerDecorateGrayHit,
      CONST.DEF_COOKIE_TIME
    );
    state.sellerDecorateGrayHit = sellerDecorateGrayHit;
  },
  // 装修引导
  SET_MATERIAL_GUIDE: (state, sellerDecorateForwardInit) => {
    commonFn.setCookie(
      'sellerDecorateForwardInit',
      sellerDecorateForwardInit,
      CONST.DEF_COOKIE_TIME
    );
    state.sellerDecorateForwardInit = sellerDecorateForwardInit;
  },
  // 是否有权限看到微信商家券
  SET_WXCOUPON_FLAG: (state, wxCouponExhibitFlag) => {
    commonFn.setCookie(
      'wxCouponExhibitFlag',
      wxCouponExhibitFlag,
      CONST.DEF_COOKIE_TIME
    );
    state.wxCouponExhibitFlag = wxCouponExhibitFlag;
  },
};

const actions = {
  // user login
  login({ commit }, userInfo) {},

  // get user info
  // getInfo({ commit, state }) {
  //   return new Promise((resolve, reject) => {
  //     getInfo(state.token).then(response => {
  //       const { data } = response

  //       if (!data) {
  //         return reject('Verification failed, please Login again.')
  //       }

  //       const { name, avatar } = data

  //       commit('SET_NAME', name)
  //       commit('SET_AVATAR', avatar)
  //       resolve(data)
  //     }).catch(error => {
  //       reject(error)
  //     })
  //   })
  // },

  // user logout
  logout({ commit, state }) {
    // removeToken(); // must remove  token  first
    commonFn.logout();
    resetRouter();
    commit('RESET_STATE');
    return true;
  },
  setName({ commit }, name) {
    commit('SET_NAME', name);
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      removeToken(); // must remove  token  first
      commit('RESET_STATE');
      resolve();
    });
  },
  getWhiteStatus: async ({ commit }, params) => {
    try {
      console.log('getWhiteStatus');
      const result = await service.post('/baseSeller/whiteListValid', params);
      const { success = false, data } = result.data;
      console.log(success, data, 'SET_WHITE_STATUS');

      if (success) {
        commit('SET_WHITE_STATUS', data.result);
        console.log(envConfig, 'envConfig');
        if (data?.result === false) {
          const res = await service.post(
            '/business/account/getSellerToken',
            {}
          );
          const { success, data } = res.data;
          if (success && data.sellerToken && envConfig.newHost) {
            commonFn.logout();
            window.location.href = `${envConfig.newHost}?sellerToken=${data.sellerToken}`;
          } else {
            window.location.href = '${envConfig.newHost}/login';
          }
        }
        return data;
      }
    } catch (error) {
      throw error;
    }
  },
  getConstantInfo({ commit }) {
    return new Promise((resolve, reject) => {
      service
        .post(
          '/baseSeller/constant',
          {},
          {
            showLoading: true,
            catchBusinessErr: true,
            // 公用接口前缀为business
            urlPrefix: 'business',
          }
        )
        .then(res => {
          console.log('res', res)
          const { data } = res.data || {};
          commit('SET_CONSTANT_INFO', data);
          resolve();
        });
    });
  },
  getMenuInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      // if (!_.isEmpty(state.menuInfo)) {
      //   resolve();
      //   return;
      // }
      service
        .get(
          '/menuInfo/queryByAccountId',
          {},
          {
            showLoading: true,
            catchBusinessErr: true,
            // 公用接口前缀为business
            urlPrefix: 'business',
          }
        )
        .then(res => {
          const { data = [] } = res.data;
          const authMenu = data.filter(item => item.type === 1);
          const storeMenu = data.filter(item => item.type === 2);
          const supplierMenu = data.filter(item => item.type === 4);
          // 菜单权限开关
          commit(
            'SET_MENU_INFO_SWITCH',
            authMenu[0] ? authMenu[0].permissionSwitch : []
          );
          commit(
            'SET_MENU_INFO',
            authMenu[0] ? authMenu[0].permissionBaseVoList : []
          );
          commit(
            'SET_STORE_MENU_INFO',
            storeMenu[0] ? storeMenu[0].permissionBaseVoList : []
          );
          //   供应商
          commit(
            'SET_SUPPLIER_MENU',
            supplierMenu[0] ? supplierMenu[0].permissionBaseVoList : []
          );
          commit('SET_ACCOUNT_TYPE', data?.map(item => item.type) || []);
          resolve();
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
